import * as Sentry from '@sentry/react'
import { createFileRoute } from '@tanstack/react-router'

import { LoginPage } from '@/pages/login/Login.page'
import { resetAuthUserStore } from '@/stores/authUser.store'
import { resetUserStores } from '@/stores/userStores'

export const Route = createFileRoute('/login')({
  beforeLoad: () => {
    resetAuthUserStore()
    resetUserStores()
    Sentry.setUser(null)
  },
  component: LoginPage,
})
